import type { PromptTemplate } from '@/components/chat/prompt-template.interface'
import type { DataTableColumn } from '@/components/data-table/data-table.interface'

const nameColumn: DataTableColumn<PromptTemplate> = {
  id: 'name',
  header: 'Name',
  accessorKey: 'name',
  isSortable: true,
}

const descriptionColumn: DataTableColumn<PromptTemplate> = {
  id: 'description',
  header: 'Description',
  cell: (row) => (
    <span className="text-sm text-muted-foreground line-clamp-1">{row.description}</span>
  ),
}

const createdAtColumn: DataTableColumn<PromptTemplate> = {
  id: 'createdAt',
  header: 'Created',
  isSortable: true,
  width: '140px',
  cell: (row) => (
    <span className="text-sm text-muted-foreground">
      {new Date(row.createdAt).toLocaleDateString()}
    </span>
  ),
}

const updatedAtColumn: DataTableColumn<PromptTemplate> = {
  id: 'updatedAt',
  header: 'Updated',
  isSortable: true,
  width: '140px',
  cell: (row) => (
    <span className="text-sm text-muted-foreground">
      {new Date(row.updatedAt).toLocaleDateString()}
    </span>
  ),
}

export const promptTemplateColumnList: DataTableColumn<PromptTemplate>[] = [
  nameColumn,
  descriptionColumn,
  createdAtColumn,
  updatedAtColumn,
]
